/**
 * Created by Languagenut on 28/08/2019.
 */

import React  from 'react';
import {Button, ListGroupItem, ListGroup,  Row , Col, Card} from 'react-bootstrap';
import CDNImage from '../../image';
import CDNAudio from '../../audio';


export default class SentenceContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    isArabic(text){
        var arabicTestString = /[\u0600-\u06FF]/;
        return arabicTestString.test(text)
    }

    getSentenceSection(sentenceObject) {
        return <Row>
                    <Col sm={12} style={{fontSize:this.isArabic(sentenceObject.word) ? "16px" : null, textAlign:this.isArabic(sentenceObject.word) ? "right" : "left" }}><b>{sentenceObject.sentence}</b></Col>
                    <br/>
        </Row>


        
    }

    componentWillReceiveProps(props){

        this.props = props;
        this.setState({
            update:true,
        })

    }

    playAudio(path){
        (new CDNAudio(path)).play();
    }

    render() {
        if (this.props.sentenceTranslations == undefined) {
            return "";
        }
        var VocabObjects = [];
        let _alert = null;
        let _alertB = null;

        if(this.props.sentenceTranslations > 10)
        {
             _alert = <i>Students will be assigned 10  at random from the list below</i>
            _alertB = <i>Students will be assigned 10  at random from the list above</i>
        }
        for (var idx = 0 ; idx < this.props.sentenceTranslations.length; idx++) {
            VocabObjects.push(<Col md={6}>{this.getSentenceSection(this.props.sentenceTranslations[idx])}</Col>);
        }
        return <div>
                <div style={{padding:"20px"}}>
                    {_alert}
                    <div >
                    <Row className="p-10">
                        {VocabObjects}
                    </Row>
                        </div>
                    {_alertB}
                </div>
            </div>
    }

}